import {useFormatCurrency} from 'platform/locale';

import {isNil} from 'ramda';

import type {Nullish} from 'shared/web';

import {useFormatReportPercentage} from './useFormatReportPercentage';

export function useFormatReportCurrencyWithPercentage() {
  const formatCurrency = useFormatCurrency();
  const formatPercentage = useFormatReportPercentage();

  return (amount: number | Nullish, percentage: number | Nullish, currency: string) => {
    if (isNil(amount)) {
      return '—';
    }
    const percentageLabel = formatPercentage(percentage);
    return `${formatCurrency(amount, currency, 2) ?? '—'} (${percentageLabel})`;
  };
}
